import React from 'react'
import './footer.css'
const Footer = () => {
  return (
    <footer>
      <div className='container__footer'>
        <i>Made with ❤ by Sweta</i>    
      </div>
      
    </footer>
  )
}

export default Footer